// extracted by mini-css-extract-plugin
export var errorsContainer = "_sx-1";
export var link = "_sx-0";